import myAxios from 'axios';
import AppConfig from '../config';
import EventBus from './EventBus';

let axios = myAxios.create({
	baseURL: AppConfig.baseUrl,
	// timeout: 5500,
	headers: {
		'Accept': 'application/json'
	}
});

axios.interceptors.response.use(
	function (response) {
		return response
	},
	(error) => {
		if (error.response && error.response.status !== undefined) {
			if (error.response.status === 403) {
				EventBus.$emit('LoginRequired', error.response);
			} else {
				EventBus.$emit('HttpErrorOccurred', error);
			}
		} else {
			EventBus.$emit('HttpErrorOccurred', error);
		}

		return Promise.reject(error);
	}
);

export default axios;
